module.exports = __webpack_public_path__ + "static/full-day-section-bubble-3-8633e1031f58b9d2ff36374a5cecc8bf.png";